<template>
<div>
    <!-- Loading State -->
    <section v-if="isLoading" class="confirming-section">
        <div class="confirming-content">
            <div class="spinner"></div>
            <div class="confirming-text">Confirming your order...</div>
        </div>
    </section>

    <section class="checkout-nav-section" v-if="!isLoading">
        <div class="checkoutnav_wrap">
            <div class="checkoutnav_div">
                <a href="#" class="link-block-73 w-inline-block"><img src="@/assets/images/NewSelf_Logo.webp" loading="lazy" sizes="(max-width: 1000px) 100vw, 1000px" srcset="@/assets/images/NewSelf_Logo-p-500.webp 500w, @/assets/images/NewSelf_Logo-p-800.webp 800w, @/assets/images/NewSelf_Logo.webp 1000w" alt="" class="image-487"></a>
                <div class="checkoutnav_progressdiv">
                    <div class="progress_step_div"></div>
                    <div class="progress_step_div current"></div>
                    <div class="progress_step_div"></div>
                    <div class="progress_step_div"></div>
                </div>
            </div>
        </div>
    </section>

    <section class="checkout-section" v-if="!isLoading && active_el==1">
        <div class="checkoutb_wrap">
            <div class="checkoutb_div">
                <div class="almostdone-div">
                    <!-- Success Icon -->
                    <div class="success-icon">
                        <svg width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="28" cy="28" r="28" fill="#01d449"/>
                            <path d="M18 28L25 35L38 22" stroke="white" stroke-width="3.5" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                    </div>

                    <div class="text-block-1151">Order Confirmed!</div>
                    <div class="text-block-1152">Thank you for your order{{ user.first_name ? ', ' + user.first_name : '' }}.</div>

                    <!-- Order Card -->
                    <div class="order-card">
                        <div class="order-items">
                            <div class="order-item" v-for="(product, index) in productsPurchased" :key="index">
                                <span class="order-item-name">{{ product.name }}</span>
                                <span class="order-item-price">${{ formatPrice(product.price) }}</span>
                            </div>
                        </div>

                        <div class="order-divider" v-if="productsPurchased.length > 0"></div>

                        <div class="order-total" v-if="productsPurchased.length > 0">
                            <span class="order-total-label">Total</span>
                            <span class="order-total-value">${{ formatPrice(orderTotal) }}</span>
                        </div>
                    </div>

                    <!-- Email Confirmation Notice -->
                    <div class="email-notice" v-if="user.email">
                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M2 4L8 9L14 4M2 12H14V4H2V12Z" stroke="#666" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                        <span>Confirmation sent to {{ user.email }}</span>
                    </div>

                    <div class="almost-button-div">
                        <a href="#" @click.prevent="active_el=2" class="button-109 w-button">Next <span class="text-span-247">-&gt;</span></a>
                    </div>
                </div>
            </div>
        </div>
    </section>

    <section class="checkout-section" v-if="!isLoading && active_el==2">
        <div class="checkoutb_wrap">
            <div class="checkoutb_div">
                <div class="almostdone-div">
                    <div class="text-block-1151">Almost Done {{user.first_name}}!</div>
                    <div class="text-block-1152">Our 100% digital process will ensure you can start your medical weightloss journey and start in as little as 2 Days.</div>
                    <div class="timeline-div">
                        <div class="timeline_line"></div>
                        <div class="linebullet_div"><img src="@/assets/images/icon_circle-icon.svg" loading="lazy" alt="" class="image-510">
                            <div>
                                <div class="text-block-1153"><strong>5-10 minutes</strong></div>
                                <div class="text-block-1154">Complete Medical Questionnaire</div>
                                <div class="text-block-1155">Fill out a short online form to submit to the doctor.</div>
                            </div>
                        </div>
                        <div class="linebullet_div"><img src="@/assets/images/icon_circle-icon.svg" loading="lazy" alt="" class="image-510">
                            <div>
                                <div class="text-block-1153"><strong>48 Hours or Less</strong></div>
                                <div class="text-block-1154">Doctor Review &amp; Prescription</div>
                                <div class="text-block-1155">Most patients do not require a video doctor visit. If approved you will receive an instant notification.</div>
                            </div>
                        </div>
                        <div class="linebullet_div"><img src="@/assets/images/icon_circle-icon.svg" loading="lazy" alt="" class="image-510">
                            <div>
                                <div class="text-block-1153"><strong>Fast Processing</strong></div>
                                <div class="text-block-1154">Our Pharmacy Processes Your Order</div>
                                <div class="text-block-1155">Our US Based, FDA 503A Pharmacies will process your order quickly (usually 24 hours or less, Mon-Thursday)</div>
                            </div>
                        </div>
                        <div class="linebullet_div"><img src="@/assets/images/icon_circle-icon.svg" loading="lazy" alt="" class="image-510">
                            <div>
                                <div class="text-block-1153"><strong>48 Hours or Less</strong></div>
                                <div class="text-block-1154">FREE 2 Day Express Shipping</div>
                                <div class="text-block-1155">You can track the packages and get updates directly in our portal.</div>
                            </div>
                        </div>
                    </div>
                    <div class="almost_bottomflex_div">
                        <div><img src="@/assets/images/stepsimage_teledoc_nS.webp" loading="lazy" sizes="(max-width: 641px) 100vw, 641px" srcset="@/assets/images/stepsimage_teledoc_nS-p-500.webp 500w, @/assets/images/stepsimage_teledoc_nS.webp 641w" alt="" class="image-511"></div>
                        <p class="paragraph-153">During this time you can access our Medical Weight Loss Biohacking Guide to help you prepare prior to receiving medication.</p>
                    </div>
                    <div class="almost-button-div">
                        <a href="#" @click.prevent="pushToMobileVerify()" class="button-109 w-button">Complete Medical Form <span class="text-span-247">-&gt;</span></a>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <!-- Added the bottom payment section from HTML -->
</div>
</template>

<script>
import {
    mapGetters
} from 'vuex';

export default {
    name: 'paymentThanks',
    props: ['baseUrl'],
    data() {
        return {
            isLoading: true,
            active_el: 1,
            productsPurchased: []
        }
    },
    computed: {
        ...mapGetters(['user']),
        orderTotal() {
            return this.productsPurchased.reduce((sum, product) => {
                const price = parseFloat(product.price) || 0;
                return sum + price;
            }, 0);
        }
    },
    created() {
        try {
            this.productsPurchased = JSON.parse(localStorage.getItem('productsPurchased') || '[]');
        } catch (e) {
            this.productsPurchased = [];
        }
    },
    methods: {
        formatPrice(price) {
            const num = parseFloat(price) || 0;
            return num.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        },
        pushToMobileVerify() {
            this.$router.push({
                name: 'verifyPhoneAndEmail'
            });
        },
        async fireGTM() {
            try {

                const amount = this.$route.query.amount;

                try{
                    if (window.tracking) {
                        window.tracking.event('purchase', {
                            funnel_step: 15,
                            event_value: amount,
                            currency: 'USD',
                            event_id: crypto.randomUUID()
                        });
                    }
                }catch(error){
                    console.log(error)
                }
                const transid = this.$route.query.trans_id;
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    'event': 'purchase',
                    'ecommerce': {
                        'transaction_id': transid,
                        'value': amount,
                        'currency': 'USD',
                    }
                });
                console.log(":white_check_mark: Google pixel fired with amount:", amount);
            } catch (error) {
                console.error(":x: Error firing Google pixel:", error);
            }

        },
    },
    mounted() {
        // Show loading for 2.5 seconds then reveal confirmed screen
        setTimeout(() => {
            this.isLoading = false;
        }, 2500);
        //this.fireGTM();
    }
}
</script>

<style scoped>
/* Confirming/Loading State */
.confirming-section {
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 100vh;
    background: #fff;
}

.confirming-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 24px;
}

.spinner {
    width: 60px;
    height: 60px;
    border: 6px solid #e5e5e5;
    border-top-color: #01d449;
    border-radius: 50%;
    animation: spin 0.6s linear infinite;
}

@keyframes spin {
    to { transform: rotate(360deg); }
}

.confirming-text {
    font-family: var(--satoshi-switch, 'Satoshi', sans-serif);
    font-size: 18px;
    font-weight: 600;
    color: var(--black, #000);
}

.selected-plan-img {
    width: 45px;
}

/* Success Icon */
.success-icon {
    margin-bottom: 20px;
}

/* Order Card */
.order-card {
    background: #fafafa;
    border-radius: 12px;
    padding: 24px 28px;
    margin: 24px auto;
    width: 100%;
    max-width: 400px;
}

.order-items {
    display: flex;
    flex-direction: column;
    gap: 14px;
}

.order-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 32px;
}

.order-item-name {
    font-family: var(--satoshi-switch, 'Satoshi', sans-serif);
    color: var(--greenbutton-dark, #01d449);
    font-size: 15px;
    font-weight: 600;
}

.order-item-price {
    font-family: var(--satoshi-switch, 'Satoshi', sans-serif);
    color: var(--black, #000);
    font-size: 15px;
    font-weight: 700;
}

.order-divider {
    height: 1px;
    background: #e5e5e5;
    margin: 16px 0;
}

.order-total {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.order-total-label {
    font-family: var(--satoshi-switch, 'Satoshi', sans-serif);
    color: var(--black, #000);
    font-size: 15px;
    font-weight: 600;
}

.order-total-value {
    font-family: var(--satoshi-switch, 'Satoshi', sans-serif);
    color: var(--black, #000);
    font-size: 18px;
    font-weight: 900;
}

/* Email Notice */
.email-notice {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    margin-top: 16px;
    font-family: var(--satoshi-switch, 'Satoshi', sans-serif);
    font-size: 13px;
    color: #666;
}
</style>
